import { ReactElement, useState } from 'react';

import { Timestamp } from 'firebase/firestore';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import dayjs, { Dayjs } from 'dayjs';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import Event from '../../types/Event';

type EventRosterDeadlineEditorProps = {
  event: Event;
  onUpdate: (updates: Partial<Event>) => void;
  defaultDate: Timestamp | null;
};

export default function EventRosterDeadlineEditor({
  event,
  onUpdate,
  defaultDate,
}: EventRosterDeadlineEditorProps): ReactElement {
  const deadline = event.rosterSetDeadline instanceof Timestamp ? event.rosterSetDeadline : null;
  const [showTime, setShowTime] = useState(
    !!(deadline && (deadline.toDate().getHours() !== 0 || deadline.toDate().getMinutes() !== 0))
  );

  const maxDate = defaultDate ? dayjs(defaultDate.toDate()) : undefined;

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{
      alignItems: { xs: 'flex-start', sm: 'center' }
    }}>
      <Typography variant="bodyMedium">Managers must set roster by:</Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack direction="row" spacing={1} sx={{
          alignItems: "center"
        }}>
          {showTime ? (
            <DateTimePicker
              value={deadline ? dayjs(deadline.toDate()) : null}
              onChange={(dt: Dayjs | null) => {
                onUpdate({ rosterSetDeadline: dt ? Timestamp.fromDate(dt.toDate()) : undefined });
              }}
              maxDateTime={maxDate}
              slotProps={{ textField: { size: 'small' } }}
            />
          ) : (
            <DatePicker
              value={deadline ? dayjs(deadline.toDate()) : null}
              onChange={(d: Dayjs | null) => {
                onUpdate({ rosterSetDeadline: d ? Timestamp.fromDate(d.endOf('day').toDate()) : undefined });
              }}
              maxDate={maxDate}
              slotProps={{ textField: { size: 'small' } }}
            />
          )}
          <Button size="small" onClick={() => setShowTime((v) => !v)}>
            {showTime ? 'Clear time' : 'Set time'}
          </Button>
        </Stack>
      </LocalizationProvider>
    </Stack>
  );
}
